import { render } from "./Welcome.page.vue?vue&type=template&id=7da0e43a&scoped=true"
import script from "./Welcome.page.vue?vue&type=script&lang=js"
export * from "./Welcome.page.vue?vue&type=script&lang=js"

import "./Welcome.page.vue?vue&type=style&index=0&id=7da0e43a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da0e43a"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QPageContainer,QPage,QIcon});qInstall(script, 'directives', {ClosePopup});
